import { render } from "./PaymentFailurePage.vue?vue&type=template&id=7c715a55"
import script from "./PaymentFailurePage.vue?vue&type=script&lang=js"
export * from "./PaymentFailurePage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__